export default __webpack_public_path__ + "static/media/iphone12.4f8d92f3.png";